(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/javascripts/constants.js');

'use strict';

let productMapping;
const containerStates = {
  CONTAINER_CLOSED: 'CONTAINER_CLOSED',
  CONTAINER_OPEN: 'CONTAINER_OPEN',
  GAME_SOLD_OUT: 'GAME_SOLD_OUT'
};
const apiPaths = {
  socket: () => '/marketplace/1/svs/activateddraws/updates',
  containers: product => "/marketplace/1/svs/containers".concat(product ? "?product=".concat(productMapping.getProductName(product)) : ''),
  activatedDraw: activatedDrawId => "/marketplace/1/svs/activateddraws/".concat(activatedDrawId),
  reservedGames: () => '/player/1/marketplace/svs/activateddraws/reserved'
};
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  module.exports = {
    apiPaths
  };
} else {
  productMapping = svs.numbergames.productMapping;
  svs.numbergames.fractiongames.constants = {
    containerStates,
    apiPaths
  };
}

 })(window);